export default {
  'clocks': [],
  'permanentRequiredFields': [
    'Salutation',
    'RequestInterest',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage',
    'DataProtectionAgreement'
  ],
  'requiredFields': {
    'cooperation': [
      'PostalCode',
      'Company',
      'RequestTopic',
      'VATNumber'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'VATNumber'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'VATNumber'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'VATNumber'
    ],
    'other': [
      'PostalCode',
    ]
  }
}
